import { useSessionExpiry } from 'hooks/customer';

/**
 * NOTE: lives in an isolated component so that the hooks internal re-renders
 * don't cause mass re-renders in child components.
 */
const SessionExpiryListener = () => {
  useSessionExpiry();
  return null;
};

export default SessionExpiryListener;
